import { useMemo } from "react";

import { ShowWithComedian } from "@/data/shows";
import { useGate } from "statsig-react";

export function useShowRowComedians(
  showcaseShow: ShowWithComedian | undefined,
  followedComedianIds: string[]
) {
  const showcaseShowsGate = useGate("showcase-shows-nearby");
  const showcaseShowsEnabled = showcaseShowsGate.value;

  const showcaseComedians = useMemo(() => {
    if (
      !showcaseShowsEnabled ||
      !showcaseShow?.show_comedians ||
      showcaseShow.show_comedians.length === 0
    ) {
      return null;
    }

    // Sort comedians by priority
    const sortedComedians = [...showcaseShow.show_comedians].sort((a, b) => {
      // prioritize in order of importance:
      // 1. the user's followed comedians
      // 2. comedians verified on Punchup (is_punchup_verified not false)
      // 3. comedians with images (about_img not null)
      const getScore = (com: typeof a) => {
        let score = 0;
        if (followedComedianIds.includes(com.id)) {
          score += 3;
        }
        if (com.is_punchup_verified) {
          score += 2;
        }
        if (com.about_img) {
          score += 1;
        }
        return score;
      };

      const scoreA = getScore(a);
      const scoreB = getScore(b);

      return scoreB - scoreA;
    });

    return sortedComedians;
  }, [showcaseShow, showcaseShowsEnabled, followedComedianIds]);

  return { showcaseComedians };
}
